<!-- 侧边导航栏 -->
<template>
  <div
    class="NavBar clearfix"
    :style="{width: $store.state.navBarWidth +'px'}">
    <div class="title">
      <img class="logo" src="../../../static/images/logo1.png" alt="logo">
      <h1 class="text" v-if="!$store.state.isCollapse">极酷物联平台</h1>
    </div>
    <el-menu
      class="el-menu-vertical-demo"
      :collapse="$store.state.isCollapse"
      background-color="#001529"
      text-color="#909399"
      active-text-color="#ffffff"
      :default-active="defaultActive"
      router
      unique-opened>
      <div v-for="(navItem, navIndex) in navList" :key="navIndex">
      <!--有2级菜单-->
      <el-submenu
        :index="navItem.function_tab">
        <template slot="title">
          <i :class="navItem.icon"></i>
          <span slot="title">{{navItem.function_name}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item
            :key="subNavIndex"
            v-for="(subNavItem, subNavIndex) in navItem.children"
            :index="navItem.function_tab+'-'+subNavItem.function_tab"
            :route="subNavItem.function_tab"
            @click="getNavBarActive(navIndex, subNavIndex)">{{subNavItem.function_name}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<script>
  import { 
    localUserInfo,
    updataBreadCrumb,
    getBreadCrumb,
    showToast
  } from "../../../static/js/utility/utility.js"
  import { navApi } from "../../../static/js/api.js"

  export default {
    name: 'NavBar',
    data() {
      return {
        // navList: [
        //   {
        //     'function_tab':'DeviceManage',
        //     'function_name':'设备管理',
        //     'children': [
        //       {
        //         'function_tab':'ProductList',
        //         'function_name':'生产列表'
        //       },
        //       {
        //         'function_tab':'ProtocolManage',
        //         'function_name':'协议管理'
        //       }
        //     ]
        //   },
        //   {
        //     'function_tab':'TemplateManage',
        //     'function_name':'模板管理',
        //     'children': [
        //       {
        //         'function_tab':'InfoTemplate',
        //         'function_name':'信息模板'
        //       }
        //     ]
        //   },
        //   {
        //     'function_tab':'ClientManage',
        //     'function_name':'客户管理',
        //     'children': [
        //       {
        //         'function_tab':'ClientList',
        //         'function_name':'客户列表'
        //       }
        //     ]
        //   },
        //   {
        //     'function_tab':'Maintain',
        //     'function_name':'平台运维',
        //     'children':[
        //       {
        //         'function_tab':'ClientMaintain',
        //         'function_name':'客户运维'
        //       },
        //       {
        //         'function_tab':'DeviceMaintain',
        //         'function_name':'设备运维'
        //       },
        //       {
        //         'function_tab':'ServerMaintain',
        //         'function_name':'服务器运维'
        //       },
        //       {
        //         'function_tab':'ServerManage',
        //         'function_name':'服务器管理'
        //       },
        //       {
        //         'function_tab':'BusinessPlan',
        //         'function_name':'企业套餐'
        //       }
        //     ]
        //   },
        //   {
        //     'function_tab':'System',
        //     'function_name':'系统',
        //     'children':[
        //       {
        //         'function_tab':'StaffManage',
        //         'function_name':'员工管理'
        //       },
        //       {
        //         'function_tab':'DictionaryManage',
        //         'function_name':'字典设置'
        //       },
        //       {
        //         'function_tab':'LogManage',
        //         'function_name':'日志管理'
        //       },
        //       {
        //         'function_tab':'ModuleManage',
        //         'function_name':'模块管理'
        //       },
        //       {
        //         'function_tab':'ThirdApplication',
        //         'function_name':'第三方应用'
        //       },
        //       {
        //         'function_tab':'APIManage',
        //         'function_name':'API管理'
        //       }
        //     ]
        //   },
        // ],
        // 导航列表
        navList: [],
        // 当前显示
        defaultActive: ''
      }
    },
    created() {
    },
    mounted() {
      // console.log('path', this.$route.path)
      // console.log('this.$store.state.isCollapse', this.$store.state.isCollapse)
      // 获取上次选中二级菜单type，刷新页面默认active
      if (getBreadCrumb() && getBreadCrumb().length > 1) {
        this.defaultActive = getBreadCrumb()[1].function_tab
      }
      this.getUserAuthList(this.$route.path)
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      // 获取导航菜单列表
      getUserAuthList: async function (path) {
        let vm = this
        // 当是登录页和仪表盘页，不能获取菜单列表
        if (path === '/' || path === '/Map') {
          console.log('123', '')
          return
        }
        let res = await navApi.getUserAuthList()
        if (res.meta.code === 200) {
          vm.navList = res.data
          vm.addIcon(res.data)
          // console.log('菜单列表', res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 一级菜单添加icon
      addIcon: function (data) {
        let navList = data
        for (let i in navList) {
          switch (navList[i].function_tab) {
            // 设备管理
            case 'DeviceManage':
              navList[i].icon = 'el-icon-tickets'
              break;
            // 模板管理
            case 'TemplateManage':
              navList[i].icon = 'el-icon-news'
              break;
            // 客户管理
            case 'ClientManage':
              navList[i].icon = 'el-icon-printer'
              break;
            // 平台运维
            case 'Maintain':
              navList[i].icon = 'el-icon-refresh'
              break;
            // 系统
            case 'System':
              navList[i].icon = 'el-icon-setting'
              break;
            default:
              break;
          }
        }
      },
      // 获取侧边导航栏选中内容,并显示对应内容
      getNavBarActive: function (navIndex, subNavIndex) {
        let navBarActive =
        [
          {
            function_tab: this.navList[navIndex].function_tab,
            function_name: this.navList[navIndex].function_name
          },
          {
            function_tab: this.navList[navIndex].children[subNavIndex].function_tab,
            function_name: this.navList[navIndex].children[subNavIndex].function_name
          }
        ]
        // 更新面包屑内容
        updataBreadCrumb(2, navBarActive)
        // console.log(JSON.parse(sessionStorage.getItem('navBarActive')))
      }
    },
    watch: {
      // 监听页面路径变化，获取菜单列表
      '$route.path': function (newVal) {
        this.getUserAuthList(newVal)
      },
      // 监听没有二级菜单，默认为空
      '$store.state.defaultActive': function (newVal) {
        this.defaultActive = 'Maintain'
      }
    }
  }
</script>

<style lang="scss">
$head-bg-color:rgba(106, 125, 143, 1);

.NavBar {
  float: left;
  color: #ffffff;
  background-color: #001529;
  box-shadow: 2px 0 6px rgba(0,21,41,.35);
  .title {
    height: 64px;
    position: relative;
    line-height: 64px;
    padding-left: 15px;
    transition: all .3s;
    background: #002140;
    overflow: hidden;
    .logo {
      width: 35px;
      height: 30px;
      display: inline-block;
      vertical-align: middle;
    }
    .text{
      color: #fff;
      display: inline-block;
      vertical-align: middle;
      font-size: 20px;
      margin: 0 0 0 12px;
      font-family: Avenir,Helvetica Neue,Arial,Helvetica,sans-serif;
      font-weight: 600;
    }
  }
}

// 侧边导航栏
.el-menu {
  border-right: none;
  .el-submenu__title {
    height: 40px;
    line-height: 40px;
    margin: 4px 0;
    color: #ffffff;
  }
  .el-menu-item.is-active {
    color: #ffffff;
    background-color: #1890ff !important;
  }
  .el-submenu.is-active {
    i, span {
      color: #fff;
    }
  }
  // 二级菜单
  .el-menu-item-group {
    .el-menu-item-group__title {
        padding: 0;
      }
    .el-menu-item {
      height: 40px;
        line-height: 40px;
      margin: 4px 0 6px;
      }
  }
}
// 导航栏折叠
.el-menu.el-menu--collapse {
  .el-submenu__title span {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
  }
  .el-submenu__icon-arrow {
    display: none;
  }
  .el-submenu-is-opened .el-submenu__title {
    margin-left: 5px;
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
   width: 100%;
}


// 悬浮侧边栏
.el-menu--vertical {
  left: 80px !important;
  .el-menu--popup {
    border-radius: 3px;
    padding: 0;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Layout/NavBar.vue